import loading from '../assets/loading.svg';

function Loading() {
  return (
    <div className="spinner">
      <img src={loading} alt="Loading" width="auto" height="50" />
    </div>
  );
}

export default Loading;
